// extracted by mini-css-extract-plugin
module.exports = {"root":"MessagesList_root__TD-Y7","header":"MessagesList_header__37VCk","chat":"MessagesList_chat__1x8Vl"};